// removed by extract-text-webpack-plugin
module.exports = {"container":"BulletinInfo-module-container-2Vb80","title":"BulletinInfo-module-title-qs5tg","short-description":"BulletinInfo-module-short-description-2UoUp","shortDescription":"BulletinInfo-module-short-description-2UoUp","body-list":"BulletinInfo-module-body-list-1L8GE","bodyList":"BulletinInfo-module-body-list-1L8GE","item":"BulletinInfo-module-item-2mDa6"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/TechnicalBulletin/components/BulletinInfo/BulletinInfo.module.scss
// module id = 1293
// module chunks = 0